// extracted by mini-css-extract-plugin
module.exports = {"menuChanges":"DropDown_menuChanges__2ukxl","menuItem":"DropDown_menuItem__74mps"};